export default {
	"components.Revise": "Revise"
}